<script>
  import { onMount } from "svelte";
  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { teamStore } from "../../../api-stores/license-store";
  import { adminAddLicensesAbandoned, adminModify } from "../../../api/admin";

  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import Body from "./Body.svelte";
  import Footer from "./Footer.svelte";
  import Header from "./Header.svelte";

  import {
    additionsStore,
    confirmedStore,
    modulePricingApiStore,
  } from "./stores";

  let oncloseOuter = () => {};
  export { oncloseOuter as onclose };
  export let licenseKind = "";
  export let modules = [];

  onMount(() => {
    if (licenseKind) {
      $additionsStore = { [licenseKind]: 1 };
    }
    modulePricingApiStore.get();
  });

  const onclose = (notify = true) => {
    $confirmedStore = false;
    if (notify) {
      adminAddLicensesAbandoned({ additions: $additionsStore });
    }
    $additionsStore = {};
    oncloseOuter();
  };

  let clientHeight = 0;
  $: style = `height:calc(100% - ${clientHeight}px)`;
  const onPurchase = async () => {
    await adminModify({
      kind: "add-licenses",
      data: { additions: $additionsStore },
    });
    teamStore.get();
    showToast({
      title: "Licenses purchased successfully",
      type: "success",
    });

    onclose(false);
  };
</script>

<Modal {onclose} size="medium" closeButton={false} closeOnOutsideClick={false}>
  <Header slot="header" />
  <Body {style} {modules} />
  <Footer {onPurchase} cancel={onclose} bind:clientHeight />
</Modal>
